import { useCallback, useEffect, useRef, useState } from "react";
import FloatingChatButton from "FloatingChatButton";
import ChatRail from "views/app-views/chat-erp/ChatRail";

// Chay lau hon hieu ung thu rail mot chut: neu animationend khong ban ra (tab an,
// trinh duyet bo qua animation) thi van phai tra nut AI Assistant ve cho nguoi dung.
const CLOSE_ANIMATION_TIMEOUT = 400;

// So huu trang thai dong/mo cua chat neo mep phai.
// Vao app chi hien nut AI Assistant; bam nut -> rail mo va nut an di; dong rail -> rail
// thu ve goc nut roi nut AI Assistant hien lai.
// Chi mot trong hai thu hien tai moi thoi diem.
const ChatLauncher = () => {
  const [isRailOpen, setIsRailOpen] = useState(false);
  const [isRailClosing, setIsRailClosing] = useState(false);
  const closeTimerRef = useRef(null);

  const clearCloseTimer = () => {
    if (closeTimerRef.current) window.clearTimeout(closeTimerRef.current);
    closeTimerRef.current = null;
  };

  // Ket thuc hieu ung: go rail va tra nut ve. Goi nhieu lan cung khong sao.
  const finishClose = useCallback(() => {
    clearCloseTimer();
    setIsRailClosing(false);
    setIsRailOpen(false);
  }, []);

  const handleOpen = () => {
    clearCloseTimer();
    setIsRailClosing(false);
    setIsRailOpen(true);
  };

  const handleRequestClose = () => {
    if (isRailClosing) return;
    setIsRailClosing(true);
    closeTimerRef.current = window.setTimeout(finishClose, CLOSE_ANIMATION_TIMEOUT);
  };

  useEffect(() => clearCloseTimer, []);

  return (
    <>
      <FloatingChatButton isHidden={isRailOpen} onOpen={handleOpen} />
      <ChatRail
        isOpen={isRailOpen}
        isClosing={isRailClosing}
        onRequestClose={handleRequestClose}
        onCloseEnd={finishClose}
      />
    </>
  );
};

export default ChatLauncher;
